import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export const fetchReport = institutionId =>
    RESTClient.getAuthenticatedObservable('daycareadmin/appreport/show', {
        institutionId,
    });
